module.exports = __webpack_public_path__ + "img/video.fae735c0.png";